import type { ReactNode } from 'react'

import StatCardS from '@/shared/ui/StatCard/StatCard.module.scss'

import FanGrowthS from '../../ClubProfileStats/components/FanGrowthCard/FanGrowthCard.module.scss'
import S from '../ClubProfileAnalytics.module.scss'
import MiniBarRow, { type MiniBarRowItem } from './MiniBarRow'

interface MiniChartCardProps {
  title: string
  items: MiniBarRowItem[]
  chartsClassName?: string
  /** Shown instead of the rows: an empty or error state. */
  state?: ReactNode
}

const MiniChartCard = ({
  title,
  items,
  chartsClassName,
  state
}: MiniChartCardProps) => {
  return (
    <section
      className={`${StatCardS.card} ${S.leftStubCard}`}
      aria-label={title}
    >
      <span className={FanGrowthS.title}>{title}</span>
      {state ?? (
        <div className={`${S.miniCharts} ${chartsClassName || ''}`}>
          {items.map(item => (
            <MiniBarRow key={item.label} item={item} />
          ))}
        </div>
      )}
    </section>
  )
}

export default MiniChartCard
